import { render, staticRenderFns } from "./OneClickCutout.vue?vue&type=template&id=234b47cb&scoped=true"
import script from "./OneClickCutout.vue?vue&type=script&lang=js"
export * from "./OneClickCutout.vue?vue&type=script&lang=js"
import style0 from "./OneClickCutout.vue?vue&type=style&index=0&id=234b47cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_f5b883aeb3d125b1f29ae1b8ca7c56aa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234b47cb",
  null
  
)

export default component.exports